import chileFlag from "../static/svgs/chileFlag.svg";
import peruFlag from "../static/svgs/peruFlag.svg";
import colombiaFlag from "../static/svgs/colombiaFlag.svg";

const staticConstants = {
  MIN_NUMBER_RUT_LEGAL_PERSON: 50000000,
  RUC_LEGAL_PERSON_BEGINNING: 20,
  RUC_NATURAL_PERSON_BEGINNINGS: [10, 15, 17],
  SUPPORT_EMAIL: "equipoadquisicion@falabella.com",
  REGISTRATION_GUIDE_URL: "https://ayudaseller.falabella.com/s/article/Como-registrarte-como-seller-en-falabella-com",
  TRAININGS_URL: "https://www.youtube.com/watch?v=9CsQvHbwIPY&list=PLV_47n2UVBnxt8GKDq6ztnGZzaN7G3xH4",
  DEFAULT_DISCLAIMER_MESSAGE_CONFIGURATION: {
    CL: {
      formUrl:
        "https://docs.google.com/forms/d/e/1FAIpQLScqh_Hd1GspqXbGGc2KAvaBQsv1qATjL4cnsILQWGKdp0NB9w/viewform?usp=sharing",
      bannedCategories: "vestuario y calzado"
    },
    CO: {
      formUrl: "https://docs.google.com/spreadsheets/d/1IxZLaOYIVI3lnpoLjvtfEdNsoizHzj4c-pbY9gx5aD0/edit?usp=drivesdk",
      bannedCategories: "vestuario, calzado y/o perfumería"
    },
    PE: {
      formUrl: "",
      bannedCategories: ""
    },
    INTL: {
      formUrl: "",
      bannedCategories: ""
    }
  },
  VALID_COUNTRIES: {
    CL: {
      countryCode: "CL",
      phoneCode: "+56",
      name: "Chile",
      logo: chileFlag,
      operatorCode: "facl"
    },
    PE: {
      countryCode: "PE",
      phoneCode: "+51",
      name: "Peru",
      logo: peruFlag,
      operatorCode: "fape"
    },
    CO: {
      countryCode: "CO",
      phoneCode: "+57",
      name: "Colombia",
      logo: colombiaFlag,
      operatorCode: "faco"
    },
    INTL: {
      countryCode: "INTL",
      phoneCode: "+00",
      name: "International",
      logo: colombiaFlag,
      operatorCode: "intl"
    }
  },
  COUNTRY_CODE_INTL: "INTL",
  ENGLISH_LANG: "en",
  SPANISH_LANG: "es",
  FORM_CODE_REGIONAL: "REGIONAL",
  FORM_CODE_INTL: "INTL",
  DEFAULT_BUSINESS_REGISTRATION_TYPE: {
    CL: "RUT",
    CO: "NIT",
    PE: "RUC"
  },
  DEFAULT_MAP_LOCATION: {
    CL: { lat: -35.675147, lng: -71.542969 },
    CO: { lat: 4.570868, lng: -74.297333 },
    PE: { lat: -9.189967, lng: -75.015152 },
    CN: { lat: 35.86166, lng: 104.195397 },
    US: { lat: 37.09024, lng: -95.712891 }
  },
  FORM_REGISTRATION_STATUS: {
    default: "Incomplete",
    error: "Error",
    success: "Successful"
  },
  SECTION_TYPE_ACCORDION: "Accordion",
  ACCORDION_ITEM_ENABLED_CLASS: "accordion-item-enabled",
  ACCORDION_ITEM_DISABLED_CLASS: "accordion-item-disabled",
  ADOBE_ANALYTICS_URL: `${process.env.REACT_APP_ADOBE_SCRIPT_URL}`,
  NATURAL_PERSON_VALUE: "natural_person",
  NATURAL_PERSON_LABEL: "Persona natural",
  NATURAL_PERSON: "Natural person",
  LEGAL_PERSON_VALUE: "legal_person",
  LEGAL_PERSON_LABEL: "Persona jurídica",
  LEGAL_PERSON: "Legal person",
  FOLLOWING_BUTTON_ACTION_OVERWRITE_FORM_CONFIG: "FOLLOWING_BUTTON_ACTION_OVERWRITE_FORM_CONFIG",
  TYPE_OF_PERSON: "legalForm",
  NO: "No",
  YES: "Yes",
  SI: "Sí",
  SI_WITHOUT_ACCENT_MARK: "Si",
  VALIDATION_MESSAGE_SPANISH_FPAY_EXISTING_ACCOUNT:
    "Este correo ya ha sido utilizado para una cuenta de Fpay, a través de la cual recibirás tus pagos. Para continuar debes ingresar uno distinto.",
  END_POINT_ECONOMIC_ACTIVITY: "economicActivity",
  END_POINT_REGIONS: "regions",
  END_POINT_CITY: "city",
  END_POINT_FACO_COUNTRY_CITY: "facoCountryCity",
  END_POINT_MUNICIPAL: "municipal",
  END_POINT_FACL_REGION_MUNICIPALS: "faclRegionMunicipals",
  END_POINT_BANKS: "sellerBanks",
  END_POINT_UPLOAD_DOCUMENT: "uploadFormDocument",
  END_POINT_SELLER: "seller",
  END_POINT_FPAY_EMAIL_VALIDATION: "validateEmailFpay",
  INPUT_TYPE_TEXT: "text",
  INPUT_TYPE_DROPDOWN: "dropdown",
  INPUT_TYPE_DROPDOWN_SEARCH: "dropdownSearch",
  INPUT_TYPE_RADIO: "radio",
  INPUT_TYPE_CHECKBOX: "checkbox",
  INPUT_TYPE_TEXTAREA: "textarea",
  INPUT_TYPE_FILE: "file",
  INPUT_TYPE_BUTTON: "button",
  INPUT_TYPE_SUBMIT: "submit",
  INPUT_TYPE_RESET: "reset",
  INPUT_TYPE_FIELDGROUP: "fieldGroup",
  INPUT_TYPE_LABEL: "label",
  INPUT_TYPE_DROPFILE: "dropfile",
  INPUT_TYPE_SEARCH_TEXT_BOX: "searchTextBox",
  INPUT_TYPE_SEARCH_SELECT: "selectSearch",
  INPUT_TYPE_ADDRESS_MAP: "addressMapSelection",
  INPUT_TYPE_LEGEND: "legend",
  INPUT_TYPE_CUSTOM_HTML: "customHtml",
  INPUT_TYPE_THUMBNAILDROPDOWN: "thumbnailDropdown",
  SERVICE_TEST: "TEST",
  SERVICE_BFF: "BFF",
  PARAM_TYPE_STATIC_VALUE: "StaticValue",
  PARAM_TYPE_GLOBAL_STATE_VALUE: "GlobalStateValue",
  DATASOURCE_TYPE_JSON: "JSON",
  DATASOURCE_TYPE_API: "API",
  DATASOURCE_TYPE_GLOBAL_VALUE: "GlobalValue",
  ACTION_HANDLER_TOGGLE_VISIBILITY: "toggleFieldVisibility",
  ACTION_HANDLER_FOCUS_SUBSECTION: "FocusSubSection",
  ACTION_HANDLER_RENDER_SUBTITLE_AND_FOCUS_SUBSECTION: "RenderSubTitleAndFocusSubsection",
  ACTION_HANDLER_RENDER_SUBTITLE_AND_ACTIVATE_PAGE_NAVIGATION: "RenderSubTitleAndActivatePageNavigation",
  ACTION_HANDLER_ACTIVATE_PAGE_NAVIGATION: "ActivatePageNavigation",
  INPUT_HANDLER_FORMATTED_RUT_NATURAL_PERSON: "getFormattedRutNaturalPerson",
  INPUT_HANDLER_FORMATTED_RUT_LEGAL_PERSON: "getFormattedRutLegalPerson",
  INPUT_HANDLER_ONLY_NUMBERS: "getOnlyNumbers",
  VALIDATE_BASED_ON_COUNTRY: "validateBasedOnCountry",
  INPUT_HANDLER_ONLY_LETTERS_AND_SPACES: "getOnlyLettersAndSpaces",
  INPUT_HANDLER_ONLY_LETTERS_AND_NUMBERS: "getOnlyLettersAndNumbers",
  INPUT_HANDLER_ONLY_LETTERS_NUMBERS_AND_SPACES: "getOnlyLettersNumbersAndSpaces",
  INPUT_HANDLER_ONLY_LETTERS_NUMERS_SPACES_AND_ESPECIAL: "getOnlyLettersNumbersSpacesAndSpecialCharacters",
  INPUT_HANDLER_ONLY_VALID_EMAILS_CHARS: "getValidEmailCharacters",
  VALIDATOR_RUT: "RutValidation",
  VALIDATOR_RUT_IS_NATURAL_PERSON: "RutIsNaturalPerson",
  VALIDATOR_RUT_IS_LEGAL_PERSON: "RutIsLegalPerson",
  VALIDATOR_RUC_IS_LEGAL_PERSON: "RucIsLegalPerson",
  VALIDATOR_RUC_IS_NATURAL_PERSON: "RucIsNaturalPerson",
  VALIDATOR_RUC: "RucValidation",
  VALIDATOR_NIT: "NitValidation",
  VALIDATOR_REGEX: "Regex",
  VALIDATOR_EMAIL: "Email",
  VALIDATOR_FILE_TYPE: "FileType",
  VALIDATOR_FILE_SIZE: "FileSize",
  VALIDATOR_HAS_CURRENT_VALUE: "hasCurrentValue",
  VALIDATOR_EQUAL_FIELD_VALUE: "EqualFieldValue",
  VALIDATOR_CONFIRMATION_FIELD_VALUE: "confirmationFieldValue",
  VALIDATOR_DOCUMENT_NUMBER_BY_ISSUING_COUNTRY: "DocumentNumberByIssuingCountry",
  VALIDATOR_DOCUMENT_NUMBER_BY_DOC_TYPE: "DocumentNumberByDocType",
  VALIDATOR_VALID_OPTION: "validOption",
  VALIDATOR_IS_NUMERIC: "IsNumeric",
  VALIDATOR_MIN_LENGTH: "MinLength",
  VALIDATOR_MAX_LENGTH: "MaxLength",
  VALIDATOR_MAX_VALUE: "MaxValue",
  VALIDATOR_MIN_VALUE: "MinValue",
  VALIDATOR_IS_CHECKED: "IsChecked",
  VALIDATOR_NOT_EMPTY: "NotEmpty",
  INPUT_ID_BUSSINESS_REG_NUMBER: "rutCompany",
  INPUT_ID_ADMIN_FIRST_NAME: "adminFirstName",
  INPUT_ID_ADMIN_LAST_NAME: "adminLastName",
  INPUT_ID_ADMIN_DOCUMENT_TYPE: "adminDocumentType",
  INPUT_ID_ADMIN_DOCUMENT_NUMBER: "adminDocumentNumber",
  INPUT_ID_ADMIN_EMAIL: "adminEmail",
  INPUT_ID_ADMIN_PHONE: "adminPhone",
  INPUT_ID_LEGAL_REPRESENTATIVE_NAME: "legalRepName",
  INPUT_ID_LEGAL_REPRESENTATIVE_LASTNAME: "legalRepLastName",
  INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_TYPE: "legalRepDocumentType",
  INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_NUMBER: "legalRepDocumentNumber",
  INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_FILE: "documentIdentification",
  INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL: "legalRepEmail",
  INPUT_ID_LEGAL_REPRESENTATIVE_PHONE: "legalRepPhone",
  INPUT_ID_DOCUMENT_ISSUING_COUNTRY: "idIssuingCountry",
  INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_NAME: "shipmentWarehouseContactName",
  INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_PHONE: "shipmentWarehouseContactPhone",
  INPUT_ID_SHIPMENT_WAREHOUSE_CONTACT_EMAIL: "shipmentWarehouseContactEmail",
  INPUT_ID_RETURN_WAREHOUSE_CONTACT_NAME: "returnWarehouseContactName",
  INPUT_ID_RETURN_WAREHOUSE_CONTACT_PHONE: "returnWarehouseContactPhone",
  INPUT_ID_RETURN_WAREHOUSE_CONTACT_EMAIL: "returnWarehouseContactEmail",
  INPUT_ID_DOCUMENT_RUT: "documentRUT",
  INPUT_ID_DOCUMENT_BANK_CERTIFICATE: "documentBankCertificate",
  INPUT_ID_SELL_IPORTED_PRODUCTS: "importedProducts",
  INPUT_ID_IN_PROGRAM_AML: "inProgramAML",
  INPUT_ID_COUNTRY_OF_REG: "registrationCountry",
  INPUT_ID_COUNTRY_SELLER: "countryHeadOffice",
  INPUT_ID_COUNTRY_SHIPMENT_WH: "countryShipmentWarehouse",
  INPUT_ID_REGION_SHIPMENT_WH: "regionShipmentWarehouse",
  INPUT_ID_REGION_SHIPMENT_LBL_WH: "optionLabel_regionShipmentWarehouse",
  INPUT_ID_CITY_SHIPMENT_WH: "cityShipmentWarehouse",
  INPUT_ID_CITY_SHIPMENT_LBL_WH: "optionLabel_cityShipmentWarehouse",
  INPUT_ID_MUNICIPAL_SHIPMENT_WH: "municipalShipmentWarehouse",
  INPUT_ID_MUNICIPAL_SHIPMENT_LBL_WH: "optionLabel_municipalShipmentWarehouse",
  INPUT_ID_ADDRESS_SHIPMENT_WH: "addressShipmentWarehouse",
  INPUT_ID_COORDINATES_SHIPMENT_WH: "coordinatesShipmentWarehouse",
  INPUT_ID_COUNTRY_RETURN_WH: "countryReturnWarehouse",
  INPUT_ID_REGION_RETURN_WH: "regionReturnWarehouse",
  INPUT_ID_REGION_RETURN_LBL_WH: "optionLabel_regionReturnWarehouse",
  INPUT_ID_CITY_RETURN_WH: "cityReturnWarehouse",
  INPUT_ID_CITY_RETURN_LBL_WH: "optionLabel_cityReturnWarehouse",
  INPUT_ID_MUNICIPAL_RETURN_WH: "municipalReturnWarehouse",
  INPUT_ID_MUNICIPAL_RETURN_LBL_WH: "optionLabel_municipalReturnWarehouse",
  INPUT_ID_ADDRESS_RETURN_WH: "addressReturnWarehouse",
  INPUT_ID_COORDINATES_RETURN_WH: "coordinatesReturnWarehouse",
  INPUT_ID_REGION_SELLER: "regionHeadOffice",
  INPUT_ID_CITY_SELLER: "cityHeadOffice",
  INPUT_ID_MUNICIPAL_SELLER: "municipalHeadOffice",
  INPUT_ID_ADDRESS_SELLER: "addressHeadOffice",
  INPUT_ID_ADDITIONAL_ADDRESS_SELLER: "aditionalAddressInfoHeadOffice",
  INPUT_ID_POSTALCODE_SELLER: "PostalCodeOffice",
  INPUT_ID_IS_A_PES: "isAPes",
  INPUT_ID_PES_NUMBER: "pesNumber",
  INPUT_ID_PES_DOCUMENT_FILE: "pesDocument",
  INPUT_ID_FACO_CERTIFY_INFO: "facoCertifyInfo",
  COUNTRY_OF_REG_ID_FIELD: "countryOfRegId",
  ADDITIONAL_FLOWS_COUNTRYARR: ["CO"],
  PARAM_NAME_FORM_SELECTOR: "form",
  PARAM_VALUE_INTL_FORM_SELECTOR: "intl",
  LANGUAGE_CODE_EN: "en",
  LANGUAGE_CODE_ES: "es",
  HOTJAR_ID: Number(process.env.REACT_APP_HOTJAR_ID),
  HOTJAR_ENABLED: process.env.REACT_APP_HOTJAR_ENABLED === "true",
  HOTJAR_VERSION: Number(process.env.REACT_APP_HOTJAR_VERSION ?? 6)
};

const constants = {
  ...staticConstants,
  TYPE_OF_PERSON_MAP: {
    [staticConstants.LEGAL_PERSON_VALUE]: staticConstants.LEGAL_PERSON,
    [staticConstants.NATURAL_PERSON_VALUE]: staticConstants.NATURAL_PERSON
  },
  DOCUMENTS_PER_COUNTRY: {
    CL: {
      [staticConstants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_FILE]: "tax_id_legal_representative"
    },
    CO: {
      documentBankCertificate: "bank_certificate",
      documentRUT: "document_rut",
      [staticConstants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_FILE]: "tax_id_legal_representative",
      deedCompanyIncorporation: "deed_company_incorporation"
    },
    PE: {
      [staticConstants.INPUT_ID_DOCUMENT_RUT]: "complete_ruc_form",
      [staticConstants.INPUT_ID_LEGAL_REPRESENTATIVE_DOCUMENT_FILE]: "tax_id_legal_representative"
    },
    INTL: {
      documentBusinessRegistration: "business_registration",
      documentIdentification: "document_identification",
      pesDocument: "pes_document"
    }
  },
  SUCCESS_PAGE_DEFAULT_TITLE: "¡Felicidades, recibimos tu solicitud de registro!",
  SUCCESS_PAGE_DEFAULT_SUBTITLE:
    "Ya hiciste tu parte, ahora es nuestro turno. En las próximas 24 horas te contactaremos al correo %userEmail% que ingresaste. Por ahora, puedes revisar nuestras capacitaciones de Falabella Seller Center.",
  SUCCESS_PAGE_DEFAULT_SUBTITLE_REPLACED: {
    "%userEmail%": [staticConstants.INPUT_ID_ADMIN_EMAIL, staticConstants.INPUT_ID_LEGAL_REPRESENTATIVE_EMAIL]
  }
};

export default Object.freeze(constants);
